export default __webpack_public_path__ + "static/media/puzzle.3c474bd9.svg";